<script lang="ts">
  import { onMount, type Snippet } from 'svelte';
  import { getTabContext } from './Tabs.svelte';

  type Props = {
    name: string;
    children: Snippet;
  };
  const props: Props = $props();
  const tabs = getTabContext();

  onMount(() => {
    tabs.register(props.name);
  });
</script>

<button
  class="tab"
  class:selected={tabs.selected.current === props.name}
  onclick={() => tabs.select(props.name)}
>
  {@render props.children()}
</button>

<style lang="scss">
  @use '~/theme/include-media' as *;

  button {
    cursor: pointer;
    background-color: #00000000;
    border: none;
    border-radius: 0;
    margin: 0;
    padding: 0.5em 1em;
    color: #888;
    border-bottom: 4px solid rgba(0, 0, 0, 0);
    display: flex;
    align-items: center;
    gap: 0.5em;
    & :global(svg) {
      opacity: 0.6;
    }
    @include media('<=420px') {
      font-size: 0.875rem;
      padding: 0.5em 0.5em;
      gap: 0.125em;
    }
  }
  button:hover {
    color: #444;
    background-color: #80808080;
    border-radius: 8px 8px 0 0;
  }
  button:hover:not(.selected) {
    border-radius: 8px;
  }
  .selected {
    color: black;
    border-bottom: 4px solid black;
    & :global(svg) {
      opacity: 1;
    }
  }

  :global(html.dark-mode) button {
    &:hover {
      color: rgb(208, 208, 208);
    }
    &.selected {
      color: white;
      border-bottom: 4px solid white;
    }
  }
</style>
